import validador from "validator"

export const notBlank = (value) => {
  if (value === undefined)
    return false
  if (value.length === 0)
    return false

  return true
}

export const matchPhone = (value) => {
  return value.match(/^[1-9][0-9]{8}$/) !== null
}

export const weight = (value) => {
}

export const isEqualTo = (value, field, data) => value === data[field]

export const constraints = {
  matchPhone: { assert: matchPhone, message: "Veuillez saisir un numéro valide."},
  isRequired: { assert: notBlank, message: "Ce champ est obligatoire !" },
  isWeight: { assert: weight, message: "La taille du fichier est trop importante. 6 Mo maximum autorisé." },
  isFloat: { assert: "isFloat", message: "Cette valeur n'est pas valide" },
  isEmail: { assert: "isEmail", message: "Cette valeur n'est pas valide" },
  isRepetead: (field) => ({ assert: isEqualTo, validWhen: true, args: [field], message: "Les deux mots de passe ne sont pas valide." })
}

export default function validate (data={}, constraints={}) {
  let errors = {}
  for (const field in constraints) {
    const rules = constraints[field]
    rules.forEach(rule => {
      const args = rule.args || []
      const validWhen = rule.validWhen || true 
      const curr_validator = typeof rule.assert === "string" ? validador[rule.assert] : rule.assert
      const value = data[field] || ""

      if (validWhen !== curr_validator(value, ...args, data) && undefined === errors[field]) {
        errors[field] = rule.message
      }
    })
  }

  return errors
}



// WEBPACK FOOTER //
// ./src/services/formValidator.js